import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logIn, logOut } from "./auth-slice";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: !window.location.href.includes("test")
    ? process.env.REACT_APP_API_URL
    : "https://apitest.glassen-it.com/component/socparser/",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const authApi = createApi({
  reducerPath: "auth/api",
  baseQuery: baseQueryWithAuth,
  endpoints: ({ mutation }) => ({
    logIn: mutation({
      query: (data) => ({
        url: `/authorization/getToken`,
        method: "POST",
        credentials: "include",
        body: data,
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled;
          localStorage.setItem("access", response.data.token);
        } catch (err) {
          dispatch(logOut());
          localStorage.clear();
        }
      },
    }),
    auth: mutation({
      query: (data) => ({
        url: `/authorization/login_get`,
        method: "POST",
        credentials: "include",
        body: data,
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled;
          const id = response.data.uid;
          dispatch(logIn(id));
        } catch (err) {
          dispatch(logOut());
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLogInMutation, useAuthMutation } = authApi;
